<template>
  <div class="containerRow" :style="computedStyle">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'containerRow',
  props: {
    width:{
      type:String,
      default:'100%'
    },
    height:{
      type:String,
      default:'48px'
    },
    calcHeight:{
      type:String,
      default:''
    },
    padding:{
      type:String,
      default:'0px'
    },
    margin:{
      type:String,
      default:'0px'
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    computedStyle(){
      let borderStr = 'none'
      if (this.border) {
        borderStr = '1px #cdcfd4 solid'
      }
      let heightStr = this.height;
      if (this.calcHeight) {
        heightStr = 'calc(100% - ' + this.calcHeight + ')'
      }
      return {
        width:this.width,
        height:heightStr,
        padding:this.padding,
        margin:this.margin,
        border: borderStr
      }
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
}
</script>
<style lang="scss" scoped>
.containerRow {
}
</style>
<style lang="scss">
.containerRow {}
</style>